export type MorningBootTheme = 'elevation' | 'journey-teal' | 'journey-gold';

export interface ThemeClasses {
  page: string;
  card: string;
  cardMuted: string;
  heading: string;
  subheading: string;
  text: string;
  textMuted: string;
  label: string;
  input: string;
  buttonPrimary: string;
  buttonSecondary: string;
  buttonGhost: string;
  progressBar: string;
  progressFill: string;
  tagA: string;
  tagT: string;
  tagG: string;
  tagActive: string;
  badge: string;
  accent: string;
}

export const THEME_CLASSES: Record<MorningBootTheme, ThemeClasses> = {
  elevation: {
    page: 'space-y-6',
    card: 'bg-white rounded-xl border border-gray-200 p-6',
    cardMuted: 'bg-gray-50 rounded-lg border border-gray-200 p-4',
    heading: 'text-2xl font-bold text-charcoal-900',
    subheading: 'text-sm text-charcoal-600',
    text: 'text-charcoal-800',
    textMuted: 'text-charcoal-500',
    label: 'text-xs font-medium uppercase tracking-wide text-charcoal-500',
    input:
      'w-full rounded-md border border-gray-300 px-3 py-2 text-sm text-charcoal-900 focus:border-indigo-300 focus:ring-2 focus:ring-indigo-100',
    buttonPrimary:
      'px-4 py-2 rounded-md bg-primary-600 hover:bg-primary-700 text-white text-sm font-medium disabled:opacity-50',
    buttonSecondary:
      'px-4 py-2 rounded-md border border-gray-300 bg-white hover:bg-gray-50 text-sm font-medium text-charcoal-700',
    buttonGhost: 'px-3 py-1.5 text-sm text-charcoal-600 hover:text-charcoal-900',
    progressBar: 'h-2 bg-gray-200 rounded-full overflow-hidden',
    progressFill: 'h-full bg-primary-600 rounded-full transition-all',
    tagA: 'bg-red-50 text-red-700 border-red-200',
    tagT: 'bg-amber-50 text-amber-800 border-amber-200',
    tagG: 'bg-emerald-50 text-emerald-800 border-emerald-200',
    tagActive: 'ring-2 ring-offset-1',
    badge: 'text-[10px] font-mono uppercase tracking-wider',
    accent: 'text-primary-600',
  },
  'journey-teal': {
    page: 'animate-fade-in space-y-6',
    card: 'bg-surface-card border border-surface-border rounded-xl p-6',
    cardMuted: 'bg-surface-elevated border border-surface-border rounded-lg p-4',
    heading: 'font-serif text-3xl text-text-primary font-light',
    subheading: 'font-sans text-text-secondary text-sm mt-1',
    text: 'font-sans text-text-primary text-sm',
    textMuted: 'font-sans text-text-tertiary text-sm',
    label: 'font-mono text-[10px] uppercase tracking-widest text-text-dim',
    input:
      'w-full bg-surface-elevated border border-surface-border rounded-lg px-3 py-2 text-sm text-text-primary placeholder:text-text-dim focus:border-teal-500/50 focus:outline-none',
    buttonPrimary:
      'px-4 py-2 rounded-lg bg-teal-500 hover:bg-teal-400 text-white text-sm font-medium disabled:opacity-50',
    buttonSecondary:
      'px-4 py-2 rounded-lg border border-surface-border bg-surface-elevated hover:bg-surface-card text-sm text-text-secondary',
    buttonGhost: 'px-3 py-1.5 text-sm text-text-tertiary hover:text-text-primary',
    progressBar: 'h-1.5 bg-surface-elevated rounded-full overflow-hidden',
    progressFill: 'h-full bg-teal-500 rounded-full transition-all duration-500',
    tagA: 'bg-red-500/15 text-red-300 border-red-500/30',
    tagT: 'bg-amber-500/15 text-amber-300 border-amber-500/30',
    tagG: 'bg-teal-500/15 text-teal-300 border-teal-500/30',
    tagActive: 'ring-1 ring-teal-500/50',
    badge: 'font-mono text-[10px] uppercase tracking-widest',
    accent: 'text-teal-500',
  },
  'journey-gold': {
    page: 'animate-fade-in space-y-6',
    card: 'bg-surface-card border border-surface-border rounded-xl p-6',
    cardMuted: 'bg-surface-elevated border border-surface-border rounded-lg p-4',
    heading: 'font-serif text-3xl text-text-primary font-light',
    subheading: 'font-sans text-text-secondary text-sm mt-1',
    text: 'font-sans text-text-primary text-sm',
    textMuted: 'font-sans text-text-tertiary text-sm',
    label: 'font-mono text-[10px] uppercase tracking-widest text-text-dim',
    input:
      'w-full bg-surface-elevated border border-surface-border rounded-lg px-3 py-2 text-sm text-text-primary placeholder:text-text-dim focus:border-gold-500/50 focus:outline-none',
    buttonPrimary:
      'px-4 py-2 rounded-lg bg-gold-500 hover:bg-gold-400 text-surface-base text-sm font-medium disabled:opacity-50',
    buttonSecondary:
      'px-4 py-2 rounded-lg border border-surface-border bg-surface-elevated hover:bg-surface-card text-sm text-text-secondary',
    buttonGhost: 'px-3 py-1.5 text-sm text-text-tertiary hover:text-text-primary',
    progressBar: 'h-1.5 bg-surface-elevated rounded-full overflow-hidden',
    progressFill: 'h-full bg-gold-500 rounded-full transition-all duration-500',
    tagA: 'bg-red-500/15 text-red-300 border-red-500/30',
    tagT: 'bg-amber-500/15 text-amber-300 border-amber-500/30',
    tagG: 'bg-gold-500/15 text-gold-300 border-gold-500/30',
    tagActive: 'ring-1 ring-gold-500/50',
    badge: 'font-mono text-[10px] uppercase tracking-widest',
    accent: 'text-gold-500',
  },
};
